/**
 * Cria uma escala linear até o limite comum e logarítmica até o teto informado.
 *
 * @param {object} pOptions Configuração da escala.
 * @param {number} pOptions.maximum Teto real da escala.
 * @param {number} pOptions.linearMaximum Limite real da faixa linear.
 * @param {number} pOptions.valueStep Incremento e arredondamento dos valores reais.
 * @param {number} pOptions.logPositions Quantidade de posições da faixa logarítmica.
 * @returns {{fromValue: Function, toValue: Function, step: number}}
 */
export function createHybridSliderScale(pOptions) {
  const {
    maximum: xMaximum,
    linearMaximum: xLinearMaximum,
    valueStep: xValueStep,
    logPositions: xLogPositions
  } = pOptions;
  const xLinearPositions = xLinearMaximum / xValueStep;
  const xLogRange = Math.log(xMaximum / xLinearMaximum);

  /** Converte o valor real para a posição visual híbrida. */
  function pvFromValue(pValue) {
    if (pValue <= xLinearMaximum) {
      return pValue / xValueStep;
    }

    const xLogProgress = Math.log(pValue / xLinearMaximum) / xLogRange;

    return xLinearPositions + xLogProgress * xLogPositions;
  }

  /** Converte a posição visual híbrida para o valor real. */
  function pvToValue(pPosition) {
    if (pPosition <= xLinearPositions) {
      return pPosition * xValueStep;
    }

    const xLogProgress = (pPosition - xLinearPositions) / xLogPositions;
    const xValue = xLinearMaximum * Math.exp(xLogProgress * xLogRange);

    return Math.round(xValue / xValueStep) * xValueStep;
  }

  return {
    fromValue: pvFromValue,
    toValue: pvToValue,
    step: 1
  };
}

export default { createHybridSliderScale };
